import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import colors from "../../../utils/colors";
import Button from "../../../components/ui/button";
import { add } from "../../../assets";

const NoItemsCard = ({
  title,
  subtitle,
  btnText,
  handleBtnClick,
}: {
  title: string;
  subtitle: string;
  btnText: string;
  handleBtnClick: () => void;
}) => {
  return (
    <Flex direction={"column"} alignItems={"center"} flex={1} my={"70px"}>
      <Text
        fontWeight={700}
        fontFamily={"lato"}
        fontSize={"18px"}
        color={colors.dark}
      >
        {title}
      </Text>
      <Text
        fontWeight={400}
        fontFamily={"lato"}
        fontSize={"16px"}
        color={colors.placeholderColor}
        mt={"10px"}
      >
        {subtitle}
      </Text>
      <Button
        text={btnText}
        icon={add}
        theme="primary"
        size="md"
        className="rounded-md h-[40px] text-sm mt-[20px]"
        onClick={handleBtnClick}
      />{" "}
    </Flex>
  );
};

export default NoItemsCard;
